import React from 'react';
import { Remote } from '@okapi/remote';
import { useSelector } from 'react-redux';
import { getRemoteTimeout } from 'common/selectors';
import { APP_MAIN_ID, DISABLE_LOYALTY_REWARDS_EXPERIMENT } from 'common/constants';
import { createGetExperiment, getDivision, getFamily, getSubdivision } from '../../page-model';
import { getRegionName } from 'features/page-model/ducks/get-model';
import { css, cx } from 'linaria';

export type ProductCarouselProps = {
  products?: string[];
  title?: string;
  carouselId?: string;
  className?: string;
  placementId?: string;
  productId?: string;
  limitMax?: number;
};

export const ProductCarousel: React.FC<ProductCarouselProps> = ({
  products,
  title = '',
  carouselId = '',
  className,
  placementId,
  productId,
  limitMax,
}) => {
  const remoteTimeout = useSelector(getRemoteTimeout);
  const disableLoyaltyRewards = useSelector(createGetExperiment(DISABLE_LOYALTY_REWARDS_EXPERIMENT));
  const productFamilyId = useSelector(getFamily);
  const division = useSelector(getDivision);
  const subdivision = useSelector(getSubdivision);
  const regionName = useSelector(getRegionName);

  const analytics = { division, subdivision, productFamilyId };

  const remoteData = {
    title: title,
    productsIds: products ?? [],
    showSeeMore: false,
    isFromPdp: true,
    useAllModal: true,
    elementBlock: carouselId,
    portalRootId: APP_MAIN_ID,
    showLoyaltyRewards: !disableLoyaltyRewards,
    analytics,
  };

  if (placementId) {
    Object.assign(remoteData, {
      sponsored: {
        placementId,
        pageType: 'productPlacements',
        acceptContent: 'sharedProductIds',
        productId: productId ?? null,
        limitMax: limitMax ?? null,
        regionName: regionName ?? null,
      },
    });
  }

  return (
    <Remote
      widget="product-carousel/root"
      id={'pdp-' + carouselId}
      data={remoteData}
      className={cx(className, wrapper)}
      serverTimeout={remoteTimeout}
    />
  );
};

export const wrapper = css`
  @media (--only-mobile) {
    [data-qa='product-image'] {
      width: 100% !important;
      height: auto !important;
    }
  }
`;
